import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { TitleTextLarge } from 'Packages/FacetDesign/Components';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const ToAccountDetails = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const maxWidth = isMobile ? '100%' : '49%';
  const alignment = isMobile ? 'center' : 'flex-end';
  const textAlign = isMobile ? undefined : 'end';

  return (
    <FDStack direction={'column'} alignItems={alignment} width={maxWidth} justifyContent={'center'}>
      <TitleTextLarge value={<strong>Facet Account:</strong>} />
      <FDStack direction={'row'} spacing={1} justifyContent={'center'} alignItems={'flex-start'}>
        <TitleTextLarge value={resource.attr('destinationAccountName')} align={textAlign} />
      </FDStack>
      <MetaField attr="destinationAccountNumber" />
      {resource.attr('secondaryDestinationAccountName') ? (
        <FDStack direction={'row'} spacing={1} justifyContent={'center'} alignItems={'flex-start'}>
          <TitleTextLarge value={resource.attr('secondaryDestinationAccountName')} align={textAlign} />
        </FDStack>) : null}
      <MetaField attr="secondaryDestinationAccountNumber" />
    </FDStack>
  );
};

ToAccountDetails.defaultProps = {
};

ToAccountDetails.propTypes = {
};

export default ToAccountDetails;
